angular.module 'zc.master.projects'

.controller 'MasterProjectsNewCtrl', ($scope, $state, $translate, Agency, Page, project, Project, productLines, MasterProject, currencies, regions, salesEntities, pricingTypes) ->
  Page.setBodyClass ''
  $translate('masterProjects.new.newSite').then (translation) ->
    Page.setTitle translation

  DIRECT_SELLING_ID = 5
  $scope.directSellingAgencyId = DIRECT_SELLING_ID

  MAX_CHANNEL_NAME_LENGTH = 21
  CLIENT_CHANNEL_PREFIX_LENGTH = 2
  MAXIMUM_APIKEY_LENGTH = MAX_CHANNEL_NAME_LENGTH - CLIENT_CHANNEL_PREFIX_LENGTH

  isUrl = (url) ->
    containHttpandDomainExpression = /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?\/?/gi
    return url.match(new RegExp(containHttpandDomainExpression))

  getHostname = (url) ->
    return new URL(url).hostname.replace(/^www\./, '')

  setExistingProjects = () ->
    # test base_url hostname to existing projects
    if ($scope.project.base_url and isUrl($scope.project.base_url))
      projectHostname = getHostname($scope.project.base_url)
      MasterProject.generateProjectApikey $scope.project.base_url
      .then (project_apikey) ->
        $scope.project.apikey = project_apikey
      $scope.existingProjects = _.filter $scope.projects, (project) ->
        projectHostname == project.hostname

  $scope.maximumApikeyLength = MAXIMUM_APIKEY_LENGTH

  $scope.project = project
  # do not include zenclerk lite because it breaks many pages
  $scope.productLines = (line for line in productLines when line.name isnt 'zenclerk_s')

  Project.all().then (projects) ->
    $scope.projects = _.map projects, (project) ->
      {
        id: project.id
        title: project.title
        apikey: project.apikey
        base_url: project.base_url
        hostname: if project.base_url then getHostname(project.base_url) else project.base_url
      }
    setExistingProjects()

  Agency.all().then (agencies) ->
    $scope.agencies = _.sortBy(agencies, 'name')

  $scope.control_percent = null

  $scope.currencies = currencies
  $scope.salesEntities = salesEntities
  $scope.regions = regions
  $scope.pricingTypes = pricingTypes

  $scope.existingProjects = []

  $scope.save = (project) =>
    if $scope.control_percent
      _.merge(project, {
        pc_control_percent: $scope.control_percent,
        sp_control_percent: $scope.control_percent,
      })

    MasterProject.create(project)
    .then (res) ->
      $state.go 'admin.projects.settings.users.invite',
        projectId: res.id

  $scope.$watch 'project.product_line', () ->
    if $scope.project.product_line != 'zenclerk' && $scope.project.pricing_type == 'tiered'
      $scope.project.pricing_type = 'volume'

  $scope.updateApikey = () ->
    setExistingProjects()

  $scope.$watch 'project.currency', () ->
    $scope.invoiceCurrencies = _.compact(_.uniq([$scope.project.currency, 'usd']))



// WEBPACK FOOTER //
// ./src/master_admin_modules/master.projects/new.controller.coffee